import { useEffect, useState } from "react";
import { Collapse, Flex, Table, Typography, Radio } from "antd";
import { buildFinancialMetricColumns, formatCurrency } from "../../../helpers/helpers"

const Business = ({ deal }) => {
  const businessMetrics = deal?.metricsData?.Business || {};
  const financialEvaluationMetrics = businessMetrics?.["Financial Evaluation"] || {};
  const categoryNames = Object.keys(financialEvaluationMetrics);
  const categoriesKey = categoryNames.join("\0");

  const [selectedCategory, setSelectedCategory] = useState(categoryNames[0] || "");

  useEffect(() => {
    const names = categoriesKey ? categoriesKey.split("\0") : [];
    if (!names.length) {
      setSelectedCategory("");
      return;
    }
    setSelectedCategory((prev) => (names.includes(prev) ? prev : names[0]));
  }, [categoriesKey]);

  const onChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const panelStyle = {
    marginBottom: 10,
    border: "none",
  };

  const aboutBusiness = (
    <div>
      <Typography style={{ fontSize: 14, marginBottom: 20 }}>
        {deal?.businessDescription || deal?.dealDescription || "Nil"}
      </Typography>
      <Flex gap="large">
        <Typography style={{ fontSize: 14 }}>
          <span style={{ fontWeight: "bold" }}>Industry: </span>
          {deal?.industryTypeName || deal?.lineOfBusinessName || "Nil"}
        </Typography>
        <Typography style={{ fontSize: 14 }}>
          <span style={{ fontWeight: "bold" }}>Location: </span>{" "}
          {deal?.cityName || deal?.businessCity || "Nil"}
        </Typography>
      </Flex>
    </div>
  );

  const pastRepaymentColumns = [
    {
      title: "Enterprises",
      dataIndex: "entName",
      key: "entName",
      width: 200,
      fixed: "left",
      render: (text) => <span style={{ color: "#40566D" }}>{text}</span>,
    },
    {
      title: "Total Repaid deals",
      dataIndex: "details",
      key: "totalReceived",
      width: 150,
      align: "center",
      render: (obj) => <span>{obj?.totalRepaid ?? "Nil"}</span>,
    },
    {
      title: "Early Repayment",
      dataIndex: "details",
      key: "earlyPayment",
      width: 150,
      align: "center",
      render: (obj) => <span>{obj?.earlyPayment ?? "Nil"}</span>,
    },
    {
      title: "Delayed By",
      children: [
        {
          title: "1-5 days",
          dataIndex: "details",
          key: "delayed5days",
          width: 100,
          align: "center",
          render: (obj) => <span>{obj?.delayed5days ?? "Nil"}</span>,
        },
        {
          title: "6-10 days",
          dataIndex: "details",
          key: "delayed10days",
          width: 100,
          align: "center",
          render: (obj) => <span>{obj?.delayed10days ?? "Nil"}</span>,
        },
        {
          title: ">10 days",
          dataIndex: "details",
          key: "morethan10days",
          width: 100,
          align: "center",
          render: (obj) => <span>{obj?.morethan10days ?? "Nil"}</span>,
        },
      ],
    },
  ];

  const financialHistoryColumns = [
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      width: 200,
      fixed: "left",
      render: (text) => <span style={{ color: "#40566D" }}>{text}</span>,
    },
    {
      title: "Funded",
      dataIndex: "fundedAmt",
      key: "fundedAmt",
      width: 200,
      align: "center",
      render: (text) => <span>{formatCurrency(text) || "Nil"}</span>,
    },
    {
      title: "Recieved",
      dataIndex: "entReceivedAmt",
      key: "entReceivedAmt",
      width: 200,
      align: "center",
      render: (text) => <span>{formatCurrency(text) || "Nil"}</span>,
    },

  ];

  const data = financialEvaluationMetrics?.[selectedCategory] || [];
  const columns = buildFinancialMetricColumns(data, (text) => (
    <span style={{ color: '#40566D' }}>{text}</span>
  ));

  const financialEvaluation = (
    <div>
      {categoryNames.length > 0 && (
        <Radio.Group onChange={onChange} value={selectedCategory} style={{ marginBottom: 20 }}>
          {categoryNames.map((category) => (
            <Radio key={category} value={category}>{category}</Radio>
          ))}
        </Radio.Group>
      )}

      <Table
        dataSource={data}
        columns={columns}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
        className="custom-table"
      />
    </div>
  )

  const collapseItems = (panelStyle) => [
    {
      key: "1",
      label: "Business Details",
      children: aboutBusiness,
      style: panelStyle,
    },
    {
      key: "2",
      label: "Financial Evaluation",
      children: financialEvaluation,
      style: panelStyle,
    },
    {
      key: "3",
      label: "Financial History with Karncy",
      children: (
        <Table
          dataSource={deal?.financialHistory}
          columns={financialHistoryColumns}
          bordered
          pagination={false}
          scroll={{ x: "max-content" }}
          className="custom-table"
        />
      ),
      style: panelStyle,
    },
    {
      key: "4",
      label: "Past Repayments",
      children: (
        <Table
          dataSource={deal?.pastRepayments}
          columns={pastRepaymentColumns}
          bordered
          pagination={false}
          scroll={{ x: "max-content" }}
          className="custom-table"
        />
      ),
      style: panelStyle,
    },
  ];

  return (
    <div className="enterprise-container">
      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        items={collapseItems(panelStyle)}
        expandIconPosition="end"
        style={{ background: "#ffffff", width: "100%" }}
      />
    </div>
  );
};

export default Business;
